import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { coberturaeducativa, Infopruebaslectura, Infopruebasmatematicas, institucioneseducativas, tasa_desercion, tasarepitencia } from '../../../services/perfiles/conponentesServices';
import { Bar, Pie, Line } from 'react-chartjs-2'; // Importar Bar para la gráfica de barras
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement } from 'chart.js'; // Importar dependencias de chart.js
import './tablaG.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const EducacionComponente = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [educacionData, setEducacionData] = useState([]);
    const [desercionData, setDesercionData] = useState([]);
    const [repietenciaData, setRepitenciaData] = useState([]);
    const [InfopruebasmatematicaData, setInfopruebasmatematicaData] = useState([]);
    const [municipio, setmunicipio] = useState([]);
    const [lecturaData, setInfopruebaslecturaaData] = useState([]);
    const [municipiolectura, setmunicipiolectura] = useState([]);
    const [institucionesData, setInstitucionesData] = useState([]);


    useEffect(() => {
        if (municipioId) {
            fetchEducacionData();
            fetchDesercionData();
            fetchrepitenciaData();
            Infopruebasmatematica();
            Infopruebaslecturas();
            instituciones();
        }
    }, [municipioId]);

    const fetchEducacionData = async () => {
        setLoading(true);
        try {
            const response = await coberturaeducativa(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setEducacionData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDesercionData = async () => {
        setLoading(true);
        try {
            const response = await tasa_desercion(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setDesercionData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const fetchrepitenciaData = async () => {
        setLoading(true);
        try {
            const response = await tasarepitencia(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setRepitenciaData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const Infopruebasmatematica = async () => {
        setLoading(true);
        try {
            const response = await Infopruebasmatematicas(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setInfopruebasmatematicaData(fetchedData);
                setmunicipio(fetchedData[0].municipio)
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const Infopruebaslecturas = async () => {
        setLoading(true);
        try {
            const response = await Infopruebaslectura(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setInfopruebaslecturaaData(fetchedData);
                setmunicipiolectura(fetchedData[0].municipio)

            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const instituciones = async () => {
        setLoading(true);
        try {
            const response = await institucioneseducativas(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setInstitucionesData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const columns = [
        {
            title: 'Sector',
            dataIndex: 'sector',
            key: 'sector',
            render: text => text || 'N/A',
            className: 'filaP',

        },
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            key: 'nombre',
            className: 'filaP',

        },
        {
            title: 'Dirección',
            dataIndex: 'direccion',
            key: 'direccion',
            className: 'filaP',

        },
        {
            title: 'Teléfono',
            dataIndex: 'telefono',
            key: 'telefono',
            render: text => text || 'N/A',
            className: 'filaP',

        },
        {
            title: 'Zona',
            dataIndex: 'zona',
            key: 'zona',
            className: 'filaP',

        },

    ];

    const columnsmatematicas = [
        {
            title: `Puntaje Matemáticas ${municipio}`,
            dataIndex: 'punt_mat',
            key: 'punt_mat',
        },
        {
            title: 'Puntaje Cauca',
            dataIndex: 'cauca',
            key: 'cauca',
        },
        {
            title: 'Puntaje Colombia',
            dataIndex: 'colombia',
            key: 'colombia',
        },
    ];
    const vaccinationCoveragePieChartData = {
        labels: ['Puntaje Matemáticas', 'Puntaje Cauca', 'Puntaje Colombia'], // Ensure these labels are correct
        datasets: [
            {
                data: [45, 30, 25], // Example data, replace this with actual numeric values
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Colors for each segment
            },
        ],
    };
    const columnsmatelectura = [
        {
            title: `Puntaje Lectura ${municipiolectura}`,
            dataIndex: 'prueba_lect',
            key: 'prueba_lect',
        },
        {
            title: 'Puntaje Cauca',
            dataIndex: 'cauca',
            key: 'cauca',
        },
        {
            title: 'Puntaje Colombia',
            dataIndex: 'colombia',
            key: 'colombia',
        },
    ];
    const lecturaoveragePieChartData = {
        labels: ['Puntaje Lectura', 'Puntaje Cauca', 'Puntaje Colombia'], // Ensure these labels are correct
        datasets: [
            {
                data: [45, 30, 25], // Example data, replace this with actual numeric values
                backgroundColor: ['#198754', '#36A2EB', '#FFCE56'], // Colors for each segment
            },
        ],
    };

    const columnsDesercion = [
        {
            title: 'Año',
            dataIndex: 'year',
            key: 'year',
        },
        {
            title: '2015 (%)',
            dataIndex: '2015',
            key: '2015',
        },
        {
            title: '2016 (%)',
            dataIndex: '2016',
            key: '2016',
        },
        {
            title: '2017 (%)',
            dataIndex: '2017',
            key: '2017',
        },
        {
            title: '2018 (%)',
            dataIndex: '2018',
            key: '2018',
        },
        {
            title: '2019 (%)',
            dataIndex: '2019',
            key: '2019',
        },
        {
            title: '2020 (%)',
            dataIndex: '2020',
            key: '2020',
        },
        {
            title: '2021 (%)',
            dataIndex: '2021',
            key: '2021',
        },
    ];

    const desercionDataMapped = desercionData.map((item) => ({
        key: item.idtasa,
        year: item.municipio,
        '2015': item['2015'],
        '2016': item['2016'],
        '2017': item['2017'],
        '2018': item['2018'],
        '2019': item['2019'],
        '2020': item['2020'],
        '2021': item['2021'],
    })).concat([
        {
            key: 'CAUCA',
            year: 'CAUCA',
            '2015': desercionData[0]?.['cau_2015'],
            '2016': desercionData[0]?.['cau_2016'],
            '2017': desercionData[0]?.['cau_2017'],
            '2018': desercionData[0]?.['cau_2018'],
            '2019': desercionData[0]?.['cau_2019'],
            '2020': desercionData[0]?.['cau_2020'],
            '2021': desercionData[0]?.['cau_2021'],
        },
        {
            key: 'COLOMBIA',
            year: 'COLOMBIA',
            '2015': desercionData[0]?.['col_2015'],
            '2016': desercionData[0]?.['col_2016'],
            '2017': desercionData[0]?.['col_2017'],
            '2018': desercionData[0]?.['col_2018'],
            '2019': desercionData[0]?.['col_2019'],
            '2020': desercionData[0]?.['col_2020'],
            '2021': desercionData[0]?.['col_2021'],
        },
    ]);
    const repitenciaDataMapped = repietenciaData.map((item) => ({
        key: item.idtasa,
        year: item.municipio,
        '2015': item['2015'],
        '2016': item['2016'],
        '2017': item['2017'],
        '2018': item['2018'],
        '2019': item['2019'],
        '2020': item['2020'],
        '2021': item['2021'],
    })).concat([
        {
            key: 'CAUCA',
            year: 'CAUCA',
            '2015': repietenciaData?.cau_2015,
            '2016': repietenciaData?.cau_2016,
            '2017': repietenciaData?.cau_2017,
            '2018': repietenciaData?.cau_2018,
            '2019': repietenciaData?.cau_2019,
            '2021': repietenciaData?.cau_2021,
        },
        {
            key: 'COLOMBIA',
            year: 'COLOMBIA',
            '2015': repietenciaData?.col_2015,
            '2016': repietenciaData?.col_2016,
            '2017': repietenciaData?.col_2017,
            '2018': repietenciaData?.col_2018,
            '2019': repietenciaData?.col_2019,
            '2020': repietenciaData?.col_2020,
            '2021': repietenciaData?.col_2021,
        },
    ]);
    const educacionColumns = [
        { title: 'Cobertura Bruta Transición', dataIndex: 'cobert_bruta_transicion', key: 'cobert_bruta_transicion' },
        { title: 'Cobertura Neta Transición', dataIndex: 'cobert_neta_transicion', key: 'cobert_neta_transicion' },
        { title: 'Cobertura Bruta Primaria', dataIndex: 'cobert_bruta_primaria', key: 'cobert_bruta_primaria' },
        { title: 'Cobertura Neta Primaria', dataIndex: 'cobert_neta_primaria', key: 'cobert_neta_primaria' },
        { title: 'Cobertura Bruta Secundaria', dataIndex: 'cobert_bruta_secundaria', key: 'cobert_bruta_secundaria' },
        { title: 'Cobertura Neta Secundaria', dataIndex: 'cobert_neta_secundaria', key: 'cobert_neta_secundaria' },
        { title: 'Cobertura Bruta Media', dataIndex: 'cobert_bruta_media', key: 'cobert_bruta_media' },
        { title: 'Cobertura Neta Media', dataIndex: 'cobert_neta_media', key: 'cobert_neta_media' },
        { title: 'Cobertura Bruta Básica', dataIndex: 'cobert_bruta_basica', key: 'cobert_bruta_basica' },
        { title: 'Cobertura Neta Básica', dataIndex: 'cobert_neta_basica', key: 'cobert_neta_basica' },
        { title: 'Cobertura Total Bruta', dataIndex: 'total_cobert_bruta', key: 'total_cobert_bruta' },
        { title: 'Cobertura Total Neta', dataIndex: 'total_cobert_neta', key: 'total_cobert_neta' },
        { title: 'Municipio', dataIndex: 'municipio', key: 'municipio' },
    ];

    // Datos para la gráfica de barras
    const chartData = {
        labels: educacionData.map(item => item.municipio), // Utiliza el nombre del municipio como etiquetas
        datasets: [
            {
                label: 'Cobertura Bruta Transición',
                data: educacionData.map(item => parseFloat(item.cobert_bruta_transicion)), // Valores de cobertura bruta de transición
                backgroundColor: 'rgba(75, 192, 192, 1)', // Color de fondo de las barras
                borderColor: 'rgba(75, 192, 192, 1)', // Color del borde de las barras
                borderWidth: 1,
            },
            {
                label: 'Cobertura Neta Transición',
                data: educacionData.map(item => parseFloat(item.cobert_neta_transicion)), // Valores de cobertura neta de transición
                backgroundColor: 'rgba(255, 159, 64, 1)', // Color de fondo de las barras
                borderColor: 'rgba(255, 159, 64, 1)', // Color del borde de las barras
                borderWidth: 1,
            },
            {
                label: 'Cobertura Bruta Primaria',
                data: educacionData.map(item => parseFloat(item.cobert_bruta_primaria)), // Valores de cobertura bruta primaria
                backgroundColor: 'rgba(153, 102, 255, 1)', // Color de fondo de las barras
                borderColor: 'rgba(153, 102, 255, 1)', // Color del borde de las barras
                borderWidth: 1,
            },
            {
                label: 'Cobertura Neta Primaria',
                data: educacionData.map(item => parseFloat(item.cobert_neta_primaria)), // Valores de cobertura neta primaria
                backgroundColor: 'rgba(255, 99, 132, 1)', // Color de fondo de las barras
                borderColor: 'rgba(255, 99, 132, 1)', // Color del borde de las barras
                borderWidth: 1,
            },
        ],
    };
    const chartDataRepitencia = {
        labels: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'], // Etiquetas para los años
        datasets: [
            {
                label: 'Municipio (Suma)',
                data: [
                    parseFloat(repietenciaData[0]?.['2015']),
                    parseFloat(repietenciaData[0]?.['2016']),
                    parseFloat(repietenciaData[0]?.['2017']),
                    parseFloat(repietenciaData[0]?.['2018']),
                    parseFloat(repietenciaData[0]?.['2019']),
                    parseFloat(repietenciaData[0]?.['2020']),
                    parseFloat(repietenciaData[0]?.['2021']),
                ],
                borderColor: '#36A2EB',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                fill: false,
                pointRadius: 5,
                pointBackgroundColor: '#36A2EB',
                borderWidth: 2,
            },
            {
                label: 'Cauca (Suma)',
                data: [
                    parseFloat(repietenciaData[0]?.cau_2015),
                    parseFloat(repietenciaData[0]?.cau_2016),
                    parseFloat(repietenciaData[0]?.cau_2017),
                    parseFloat(repietenciaData[0]?.cau_2018),
                    parseFloat(repietenciaData[0]?.cau_2019),
                    parseFloat(repietenciaData[0]?.cau_2020),
                ],
                borderColor: '#FF6384',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                fill: false,
                pointRadius: 5,
                pointBackgroundColor: '#FF6384',
                borderWidth: 2,
            },
            {
                label: 'Colombia (Suma)',
                data: [
                    parseFloat(repietenciaData[0]?.col_2015),
                    parseFloat(repietenciaData[0]?.col_2016),
                    parseFloat(repietenciaData[0]?.col_2017),
                    parseFloat(repietenciaData[0]?.col_2018),
                    parseFloat(repietenciaData[0]?.col_2019),
                    parseFloat(repietenciaData[0]?.col_2020),
                ],
                borderColor: '#FFCD56',
                backgroundColor: 'rgba(255, 205, 86, 0.2)',
                fill: false,
                pointRadius: 5,
                pointBackgroundColor: '#FFCD56',
                borderWidth: 2,
            },
        ]
    };
    const chartDatadesercionData = {
        labels: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'], // Etiquetas para los años
        datasets: [
            {
                label: 'Municipio (Suma)',
                data: [
                    parseFloat(desercionData[0]?.['2015']),
                    parseFloat(desercionData[0]?.['2016']),
                    parseFloat(desercionData[0]?.['2017']),
                    parseFloat(desercionData[0]?.['2018']),
                    parseFloat(desercionData[0]?.['2019']),
                    parseFloat(desercionData[0]?.['2020']),
                    parseFloat(desercionData[0]?.['2021']),
                ],
                borderColor: '#36A2EB',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                fill: false,
                pointRadius: 5,
                pointBackgroundColor: '#36A2EB',
                borderWidth: 2,
            },
            {
                label: 'Cauca (Suma)',
                data: [
                    parseFloat(desercionData[0]?.cau_2015),
                    parseFloat(desercionData[0]?.cau_2016),
                    parseFloat(desercionData[0]?.cau_2017),
                    parseFloat(desercionData[0]?.cau_2018),
                    parseFloat(desercionData[0]?.cau_2019),
                    parseFloat(desercionData[0]?.cau_2020),
                ],
                borderColor: '#FF6384',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                fill: false,
                pointRadius: 5,
                pointBackgroundColor: '#FF6384',
                borderWidth: 2,
            },
            {
                label: 'Colombia (Suma)',
                data: [
                    parseFloat(desercionData[0]?.col_2015),
                    parseFloat(desercionData[0]?.col_2016),
                    parseFloat(desercionData[0]?.col_2017),
                    parseFloat(desercionData[0]?.col_2018),
                    parseFloat(desercionData[0]?.col_2019),
                    parseFloat(desercionData[0]?.col_2020),
                ],
                borderColor: '#FFCD56',
                backgroundColor: 'rgba(255, 205, 86, 0.2)',
                fill: false,
                pointRadius: 5,
                pointBackgroundColor: '#FFCD56',
                borderWidth: 2,
            },
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: 'Deserción y Repitencia (Popayán, Cauca, Colombia) por Año',
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Año',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Valor de Deserción/Repitencia',
                },
                ticks: {
                    beginAtZero: true,
                },
            },
        },
    };
    return (
        <div className='page-content'>
            {loading ? (
                <Spin size="large" />
            ) : (
                <>
                    <h2 className="center-title">Cobertura Educativa</h2>
                    <Table
                        columns={educacionColumns}
                        dataSource={educacionData.map((item, index) => ({ ...item, key: index }))}
                        pagination={false}
                    />
                    <div className='chart-container'>
                        <Bar data={chartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, title: { display: true, text: 'Cobertura Educativa por Municipio' } } }} />

                    </div>

                </>)}
            <div >
                <h2 className="center-title">Tasa de deserción Sector Oficial
                </h2>
                <Table
                    columns={columnsDesercion}
                    dataSource={desercionDataMapped}
                    pagination={false}
                />
                <div className='chart-container'>
                    <Line data={chartDatadesercionData} options={options} />
                </div>
                <h2 className="center-title">Tasa de repitencia sector oficial</h2>
                <Table
                    columns={columnsDesercion}
                    dataSource={repitenciaDataMapped}
                    pagination={false}
                />
                <div className='chart-container'>
                    <Line data={chartDataRepitencia} options={options} />
                </div>
            </div>
            <div className='content-cultivos'>
                <h3 className="center-title">Pruebas saber 11, Matemáticas 100 puntos</h3>

                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Table
                        columns={columnsmatematicas}
                        dataSource={InfopruebasmatematicaData}
                        rowKey="id_pruebas"
                        pagination={false}
                    />
                )}
                <div className="chart-container">
                    <Pie data={vaccinationCoveragePieChartData} />
                </div>
                <h3 className="center-title"> Pruebas saber 11, Lectura 100 puntos</h3>

                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Table
                        columns={columnsmatelectura}
                        dataSource={lecturaData}
                        rowKey="id_pruebas"
                        pagination={false}
                    />
                )}
                <div className="chart-container">
                    <Pie data={lecturaoveragePieChartData} />
                </div>
            </div>
            <h2 className="center-title"> Instituciones Educativas</h2>

            <Spin spinning={loading}>
                <Table columns={columns}
                    dataSource={institucionesData}
                    rowKey="id_instituciones"
                    pagination={{ pageSize: 5 }}
                />
            </Spin>

        </div>
    );
};

export default EducacionComponente;
